<template>
  <div class="six-imgbox">
    <Loading v-if="isLoading" />
    <NoData v-if="!isLoading && periodData.length === 0" />
    <template v-else>
      <!-- 期數的tabber -->
      <template v-if="periodData.length">
        <div class="six-imgbox__control">
          <div class="c8-select">
            <div class="c8-select__content">
              <a
                v-for="(period, periodIndex) in periodData"
                :key="`period-${periodIndex}`"
                class="button-outline c8-select__content__item"
                :class="{ active: isActivePeriod.index === periodIndex }"
                @click.prevent="showImage(periodIndex, period)"
              ><span class="button-outline__text">{{
                period.period
              }}</span></a>
            </div>
          </div>
        </div>
      </template>

      <!-- 圖片顯示區域 -->
      <!-- <NoData v-if="newsPaperInfo.imgURL === ''" /> -->
      <div class="six-imgbox__content" style="min-height: 700Px;">
        <div
          v-if="isActivePeriod.index > 0"
          class="content-1__films__previous"
          @click="nextPeriod"
        >
          <img
            :src="require('@/assets/style/desktop/img/slider-left.svg')"
            alt=""
          >
        </div>
        <div
          v-if="isActivePeriod.index >= 0 && isActivePeriod.index !== periodData.length - 1"
          class="content-1__films__next"
          @click="previousPeriod"
        >
          <img
            :src="require('@/assets/style/desktop/img/slider-right.svg')"
            alt=""
          >
        </div>
        <div class="content-1__films" style="min-height: 800Px;">
          <div class="six-imgbox__img">
            <transition name="fade" mode="out-in">
              <div
                v-if="currentCanvasNewsURL === ''"
                class="paper-loading-text"
              >
                <span v-if="paperFetchMessage === ''">
                  加载中
                </span>
                <span v-else>
                  {{ paperFetchMessage }}
                </span>
              </div>
              <div v-else class="image-wrapper">
                <div v-if="isActivePeriod.index >= 0 && isActivePeriod.index !== periodData.length - 1" class="check-preious" @click="previousPeriod">
                  <span class="check-preious__text">查看上期详情</span>
                </div>
                <el-image
                  :key="defaultTab"
                  :src="currentCanvasNewsURL"
                  :preview-src-list="[currentCanvasNewsURL]"
                />
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div v-if="drawPaperFail" class="draw-paper-fail"></div>
      <div>
        <component :is="type" v-model="overlayMask" :period="currentPeriod" :cp-id="tukuCategory[0]" :period-data="periodData" />
      </div>
    </template>
    <div v-show="overlayMask" class="overlay-mask">
      <div class="loader"></div>
    </div>
  </div>
</template>
<script>
import { getNewsPaperPeriod } from '@/api/desktop/images'
import { getThisAndLastYear, imageSearchNoDataMsg } from '@/utils/commonLib'
import { paperPollingRefCancel } from '@/draw-core/utils/common'
import NoData from '@/components/web/common/NoData'
import Loading from '@/components/web/common/skeleton/imagesLoading'
import wfpk10 from '@/components/web/pages/images/wfpk10'
import jspk10 from '@/components/web/pages/images/jspk10'

export default {
  name: 'CanvasImagesList',
  components: {
    NoData,
    Loading,
    wfpk10,
    jspk10
  },
  props: {
    tukuCategory: {
      type: Array,
      required: true,
      default: () => []
    },
    type: {
      type: String,
      default: 'wfpk10'
    },
    currentTabIndex: {
      type: Number,
      default: 0
    },
    previousTabIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isActivePeriod: {
        index: null
      }, // 預設選擇最新一期
      defaultTab: '', // 預設讓今天高亮
      isLoading: false,
      periodData: [],
      newsPaperInfo: {
        imgURL: '',
        period: ''
      },
      overlayMask: false,
      imageSearchNoDataMsg,
      drawPaperFail: false
    }
  },
  computed: {
    currentCanvasNewsURL() {
      return this.$store.state.lottery.currentCanvasTukuURL
    },
    currentPeriod() { // 目前期號
      return this.periodData[this.isActivePeriod.index] && this.periodData[this.isActivePeriod.index].period ? this.periodData[this.isActivePeriod.index].period : ''
    },
    paperFetchMessage() {
      return this.$store.state.lottery.paperFetchMessage
    }
  },
  watch: {
    currentPeriod() {
      this.$store.dispatch('lottery/setPaperFetchMessage', '')
    }
  },
  created() {
    this.getImagePeried()
  },
  methods: {
    async getImagePeried() {
      if (!this.tukuCategory[0]) return
      const query = {
        categoryID: this.tukuCategory[0],
        count: 30
      }
      const [data, err] = await getNewsPaperPeriod(query)

      if (err) {
        console.error(`[error]:`, err)
        return
      }

      this.periodData = data
      this.defaultTab = data[0].period
      this.setActivePeriodIndex()
    },
    showImage(val, period) {
      paperPollingRefCancel(this)
      this.isActivePeriod.index = val
      this.defaultTab = period.period
      this.updatePeriod(this.currentPeriod)
    },
    previousPeriod() {
      const index = this.isActivePeriod.index + 1
      this.isActivePeriod.index = index
      this.defaultTab = this.periodData[index].period
      this.updatePeriod(this.currentPeriod)
    },
    nextPeriod() {
      const index = this.isActivePeriod.index - 1
      this.isActivePeriod.index = index
      this.defaultTab = this.periodData[index].period
      this.updatePeriod(this.currentPeriod)
    },
    getThisAndLastYear,
    setActivePeriodIndex() {
      const { period, action, authorization } = this.$route.query
      const activePeriod = this.periodData.findIndex((item) => item.period === period)

      // 有 action 且 authorization 參數 且 找不到期數
      if (action === 'draw' && authorization !== '' && activePeriod < 0) { // 自動產圖判斷(虛擬機只戳電腦版)
        this.drawPaperFail = true // chromedp 爬蟲用
        this.isActivePeriod.index = activePeriod || null
        return
      }

      this.$sentry.captureMessage(`${this.type} setActivePeriodIndex this.$route.query：${JSON.stringify(this.$route.query)}`, {
        level: 'info',
        extra: {
          fullData: activePeriod
        }
      })

      // 預設都會執行此邏輯
      if (this.previousTabIndex === null && activePeriod >= 0) { // 從網址參數進入
        this.isActivePeriod.index = activePeriod >= 0 ? activePeriod : 0
        this.updatePeriod(this.currentPeriod)
      } else if ((this.previousTabIndex === null && this.currentTabIndex === 0 && this.$store.state.lottery.directEnterImageItem) || this.previousTabIndex !== null && this.previousTabIndex !== this.currentTabIndex) { // 從選單直接進入 pk10 || pk10 切換子彩種
        this.resetActivePeriodIndex()
      } else if (activePeriod === -1) {
        this.resetActivePeriodIndex()
      } else {
        alert(this.imageSearchNoDataMsg)
        this.resetActivePeriodIndex()
      }
    },
    updatePeriod(currentPeriod = '') {
      // 網址更新 彩種、期號
      this.$router.push({
        query: {
          lotteryCode: this.type || 'wfpk10',
          period: currentPeriod
        }})
    },
    resetActivePeriodIndex() {
      this.isActivePeriod.index = 0
      this.updatePeriod(this.currentPeriod)
    }
  }
}
</script>

<style lang="scss" scoped>
.imagecontent {
  border: #b7b7b7 1px solid;
  &__header {
    display: flex;
    padding: 1rem 10px;
    min-height: 1rem;
    justify-content: space-between;
    align-items: center;
    border-bottom: #b7b7b7 1px solid;
    &__left {
      width: 15%;
      font-size: 1rem;
    }
    &__title {
      width: 70%;
      font-size: 2rem;
      text-align: center;
    }
    &__right {
      width: 15%;
      font-size: 1rem;
    }
  }
  &__select {
    padding: 1rem 10px;
    min-height: 1rem;
    border-bottom: #b7b7b7 1px solid;
    &__item {
      border-radius: 10%;
      margin-right: 10px;
      padding: 5px;
      background-color: #d6d6d6;
      border: #a0a0a0 1px solid;
      &--active {
        background-color: #178aff;
      }
    }
  }
  &__contant {
    width: 1140px;
    padding: 30px;
    display: flex;
    justify-content: center;
    align-self: center;
    &--fluid {
      min-width: 100%;
    }
  }
}
.six-imgbox {
  display: flex;
  flex-direction: column;
  width: 100%;
  &__title {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    box-sizing: border-box;
    border-bottom: solid 1px #ebebeb;
    &__left {
      flex: 1;
      display: flex;
      justify-content: flex-start;
      .button-outline {
        border: none;
      }
    }
    &__content {
      display: flex;
      justify-content: center;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;
      max-width: 600px;
    }
    .imagecontent__header__right {
      flex: 1;
      display: flex;
      justify-content: flex-end;
    }

    &__right {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      &__text {
        margin: 0 8px;
      }
    }
  }
  &__control {
    min-height: 50px;
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    border-bottom: solid 1px #ebebeb;
    position: relative;
    &__icon {
      position: absolute;
      width: 16px;
      height: 16px;
      right: 16px;
      top: 16px;
      cursor: pointer;
      > img {
        width: 100%;
      }
    }
  }
  &__content {
    padding: 16px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    position: relative;
    .content-1__films {
      border: 0;
    }
    .six-imgbox__img {
      width: 100%;
      text-align: center;
      > img {
        max-width: 100%;
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter, .fade-leave-to
/* .component-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
.image-wrapper {
  position: relative;
  width: 62.5rem;
  margin: 0 auto;
}
.check-preious {
  font-size: 0.75rem;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: normal;
  position: absolute;
  top: 4.25rem;
  right: 1.875rem;
  border: 0.0625rem solid #ffffff;
  padding: 0.125rem 0.5rem;
  border-radius: 1.25rem;
  z-index: 1;
  cursor: pointer;
  user-select: none;
  font-family: $normal-font-family;
}
.overlay-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
  .loader {
    width: 1.875rem;
    padding: 0.25rem;
    aspect-ratio: 1;
    border-radius: 50%;
    background: #ffffff;
    --_m:
      conic-gradient(#0000 10%,#000),
      linear-gradient(#000 0 0) content-box;
    -webkit-mask: var(--_m);
            mask: var(--_m);
    -webkit-mask-composite: source-out;
            mask-composite: subtract;
    animation: spin 1s infinite linear;
  }
}
@keyframes spin {to{transform: rotate(1turn)}}

.paper-loading-text {
  padding: 10PX 0;
  color: #bababa;
  font-size: 14PX;
  text-align:center;
}
</style>
